import * as React from 'react';

const defaultOptions = {};

export default function useIntersectionObserver(
  callback,
  options = defaultOptions
) {
  const _ref = React.useRef(null);
  const ref = options.ref || _ref;

  React.useEffect(() => {
    let observer;

    if (
      ref.current &&
      callback &&
      options &&
      'IntersectionObserver' in window
    ) {
      observer = new IntersectionObserver(
        (entries, o) => entries.map((entry) => callback(entry, o)),
        options
      );
      observer.observe(ref.current);
    }

    return () => {
      observer?.disconnect();
    };
  }, [callback, ref, options]);

  return ref;
}
